import * as UI from "@iyk/ui"
import * as React from "react"

import { Assets } from "../../../packages/assets.ts"
import { classForCard } from "../../../packages/card.tsx"
import { VerifiedProfileIcon } from "../ui/icons.tsx"
import { Link, Routes } from "../ui/link.tsx"

export const UserProfileCard = (props: UserProfileCard.Props) => {
  const hasAtLeastOneProof = props.totalCheckIns > 0 || props.totalMerchOwned > 0
  return (
    <Link
      to={Routes.collection(props.userId)}
      className={UI.cx(classForCard, "flex flex-col justify-between p-3 h-[210px]")}
    >
      <img
        src={Assets.images.avatar}
        alt="Avatar"
        className="size-7 rounded-sm bshadow bshadow-grayA-3"
      />
      {hasAtLeastOneProof ? (
        <div className="flex items-center gap-3">
          {hasAtLeastOneProof && <VerifiedProfileIcon className="size-5" />}
          <div className={classForUserLabel}>
            {props.variant === "profile" ? (
              <React.Fragment>
                <span>{props.username}</span>
                <br />
                <span>Since {props.since}</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span className="text-gray-11">Owner:</span>
                <br />
                <span>{props.username}</span>
              </React.Fragment>
            )}
          </div>
        </div>
      ) : (
        <span className={classForUserLabel}>{props.username}</span>
      )}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <UI.Icon.Location />
            <span className="text-xs">{props.totalCheckIns}</span>
          </div>
          <div className="flex items-center gap-2">
            <UI.Icon.Badge />
            <span className="text-xs">{props.totalMerchOwned}</span>
          </div>
        </div>
        <span className={UI.classForButton({ size: "sm", kind: "shaded" })}>
          <UI.Icon.Eye /> View {props.variant === "profile" && "my"} collection
        </span>
      </div>
    </Link>
  )
}

const classForUserLabel = UI.cx(
  "uppercase text-[11px] leading-[16px] tracking-upper font-departure-mono",
)

namespace UserProfileCard {
  export type Props = {
    userId: string
    username: string
    since: string
    totalCheckIns: number
    totalMerchOwned: number
    variant: "owner" | "profile"
  }
}
